module.exports = __webpack_public_path__ + "img/people-pants-simple.2dcf91dc.svg";